import { Component, OnInit } from '@angular/core';
import { LoadingOverlayService } from '@user/core/services';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {
  constructor(
    public loadingService: LoadingOverlayService
  ) {
  }

  ngOnInit(): void {
  }

}
